'use client';

import { useState } from 'react';
import Navbar from '../components/Navbar';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import styles from './Terms.module.css';

export default function TermsPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <main>
      <Navbar toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
      <Menu isOpen={isMenuOpen} />
      
      <div className={styles.termsContainer}>
        <div className={styles.termsHeader}>
          <h1>Token Early Sale Terms and Conditions</h1>
        </div>
        
        <div className={styles.termsContent}>
          <p>
            These Token Sale Terms and Conditions ("Agreement") govern your participation in the early sale of GAM (the "Token") offered by GameMax Network Group Corp.("Company"), registered in the British Virgin Islands. By participating in the early sale, you agree to be bound by these terms.
          </p>
          
          <h2>Eligibility:</h2>
          <ul>
            <li>Participation in the early sale is restricted to individuals who meet the eligibility criteria outlined by the Company. You are not eligible to participate if you are a citizen, national, resident (tax or otherwise), domiciliary, and/or green card holder of any geographic area or country:</li>
            <li>(i) where the sale of GAM may be construed as the sale of a security (however named), financial service, or investment product under applicable law, or</li>
            <li>(ii) where participation in token sales is prohibited by applicable law, decree, regulation, treaty, or administrative act.</li>
            <li>You agree to provide any necessary identity verification documents when requested in order to carry out relevant eligibility checks. It is your responsibility to ensure that your participation complies with the laws and regulations of your jurisdiction.</li>
          </ul>
          
          <h2>United States Persons:</h2>
          <p>By clicking the connect your wallet button on the gam.one website, you certify that you:</p>
          <ul>
            <li>(i) are a US Person as defined in Rule 902(k) of Regulation S under the U.S. Securities Act of 1933 and</li>
            <li>(ii) meet the requirements to be deemed an "accredited investor" as defined under Regulation D under the U.S. Securities Act of 1933.</li>
            <li>(iii) The tokens in the US token sale have not been registered under the US Securities Act or any other law or with any regulatory authority. GameMax Network Group Corp. does not consider the tokens to be securities but the tokens offered in this US token sale may only be sold to persons who have been verified as accredited investors under Rule 506(c) of Regulation D under the Securities Act. No information on this site is intended to be an offer to buy or a solicitation of an offer to sell any tokens where not permitted by applicable law. Information on this site may not be copied or republished.</li>
          </ul>
          
          <h2>Non-United States Persons:</h2>
          <ul>
            <li>(i) you are not U.S. Persons,</li>
            <li>(ii) you are not accessing this site for the account or benefit of any U.S. Person and</li>
            <li>(iii) you are accessing this site from outside of the United States. The Tokens in the non-US token sale have not been registered under the US Securities Act or any other law or with any regulatory authority. GameMax Network Group Corp. does not consider the tokens to be securities but the tokens may not be offered or sold in the United States or to or for the account or benefit of any U.S. person. No information on this site is intended to be an offer to buy or a solicitation of an offer to sell any tokens where not permitted by applicable law. Information on this site may not be copied or republished.</li>
          </ul>
          
          <h2>Early Sale Period:</h2>
          <ul>
            <li>The early sale period, including start and end dates, will be clearly communicated by the Company. Participants must contribute within the designated timeframe.</li>
            <li>Important: The early sale may have multiple rounds with varying prices, and participants should adhere to the dates and instructions for each round.</li>
          </ul>
          
          <h2>Contribution:</h2>
          <ul>
            <li>Accepted Contributions: Participants may contribute in ETH, USDT, BNB, MATIC, BTC, USDC, or other cryptocurrencies as specified by the Company. Participants may also purchase using credit cards. All contribution amounts and any associated terms will be clearly outlined on the GameMax website at www.gam.one.</li>
            <li>Contribution Limit: There may be a minimum and maximum contribution amount specified for each round of the sale. Details will be provided on the website.</li>
          </ul>
          
          <h2>Token Distribution:</h2>
          <ul>
            <li>The Company will communicate the distribution timeline and process. Tokens will be distributed to eligible participants at the time of the Token Generation Event (TGE), after which participants will receive their tokens.</li>
            <li>Token Delivery: Distribution will occur directly to wallets provided by participants during the sale.</li>
          </ul>
          
          <h2>Token Lock-Up:</h2>
          <ul>
            <li>Any lock-up period for the distributed tokens, if applicable, will be clearly communicated by the Company prior to distribution.</li>
            <li>Participants must adhere to the specified lock-up conditions. These lock-up terms may vary based on the sale round and may include restrictions on the transfer or sale of GAM tokens for a specified period.</li>
          </ul>
          
          <h2>Refunds:</h2>
          <ul>
            <li>Contributions are non-refundable, except as otherwise explicitly stated in this Agreement or required by applicable law. Once contributions are made, participants acknowledge that they assume all risks associated with the sale.</li>
            <li>If refunds are applicable, they will be processed in accordance with applicable laws and the Company's procedures.</li>
          </ul>
          
          <h2>Regulatory Compliance:</h2>
          <ul>
            <li>Participants are solely responsible for ensuring that their participation in the sale complies with relevant regulations in their jurisdiction. The Company reserves the right to refuse contributions from participants in jurisdictions where participation is prohibited or restricted.</li>
            <li>The Company will comply with applicable financial regulations and may take action as needed to meet compliance obligations.</li>
          </ul>
          
          <h2>Risks:</h2>
          <ul>
            <li>Acknowledgment of Risk: By participating in the sale, you acknowledge and understand the risks involved, including market volatility, regulatory changes, technical risks, and the potential loss of your contribution.</li>
            <li>The Company is not liable for any losses incurred as a result of market fluctuations or other external factors affecting the price or value of GAM tokens.</li>
            <li>There is no guarantee that the $GAM token will have any value or be tradable on any exchanges.</li>
          </ul>
          
          <h2>Governing Law:</h2>
          <p>This Agreement shall be governed by and construed in accordance with the laws of the British Virgin Islands, without regard to its conflict of law principles.</p>
          
          <h2>Amendments:</h2>
          <ul>
            <li>The Company reserves the right to amend these Token Sale Terms and Conditions at any time. If any amendments are made, participants will be notified accordingly, and continued participation in the sale constitutes acceptance of the amended terms.</li>
            <li>It is the responsibility of each participant to stay updated on the current Terms of Service by regularly checking the GameMax website.</li>
          </ul>
          
          <h2>Miscellaneous:</h2>
          <ul>
            <li>Notices: Any notices or communications related to this Agreement will be sent to the contact information provided by the participant. Participants are responsible for keeping their contact details updated.</li>
            <li>Force Majeure: The Company will not be liable for any failure or delay in performance due to events beyond its control, including but not limited to acts of God, war, pandemics, economic crises, or any other unforeseen circumstances.</li>
          </ul>
          
          <h2>Important Disclaimer:</h2>
          <ul>
            <li>Not an Investment: The GAM token is a utility token and is not to be considered an investment product. It is not being offered as an investment vehicle and should not be purchased with the expectation of profit. The token is designed for use within the GameMax ecosystem, providing users access to services, games, rewards, and community participation. Participants should not view the token purchase as a speculative investment.</li>
          </ul>
          
          <p className={styles.termsFooter}>
            By participating in the early sale, you confirm that you have read, understood, and agreed to these Token Sale Terms and Conditions. If you do not agree to these terms, please refrain from participating in the early sale.
          </p>
          
          <p className={styles.companyInfo}>
            GameMax Network Group Corp.
          </p>
          
          <p className={styles.dateInfo}>
            February 2025
          </p>
        </div>
      </div>
      
      <Footer />
    </main>
  );
} 